import { Link } from "react-router-dom";
import { PersonAvatar } from "components/Person/PersonAvatar";

/**
 * The name cell of a list of who opened or clicked. A row with a live person
 * links to them. A row without one never links: there is nobody to open (it
 * used to link to /people/undefined). That is the row of an archived or
 * deleted contact, which still has its own address.
 */
export const EventPersonName = ({ event }: { event: any }) => {
  const person: IEndUser | undefined = event?.EndUser || undefined;
  if (person?.id) {
    return (
      <Link to={`/people/${person.id}`}>
        <PersonAvatar
          email={person.email}
          name={person.name || person.firstName || person.lastName}
          id={person.id}
          size={36}
          className="mr-2"
        />
        <span className="ml-1">
          {person.name || `${person.firstName || ""} ${person.lastName || ""}`}
        </span>
      </Link>
    );
  }
  return (
    <span>
      <PersonAvatar email={event?.email} size={36} className="mr-2" />
    </span>
  );
};

/** The address cell: a link for a live person, plain text for anyone else. */
export const EventPersonEmail = ({ event }: { event: any }) => {
  const person: IEndUser | undefined = event?.EndUser || undefined;
  if (person?.id) {
    return (
      <Link to={`/people/${person.id}`}>
        <div>
          <div>{person.email || ""}</div>
        </div>
      </Link>
    );
  }
  return <div>{event?.email || ""}</div>;
};
